import React from "react";
import Box from "@mui/material/Box";
import { useAuth } from "../../context/AuthContext";
import { HashLink } from "react-router-hash-link";
import HelpDrawerText from "./HelpDrawerText";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import CurrencyFormat from "react-currency-format";
import EasyInvoiceSample from "./EasyInvoiceSample";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const OrdersPartial = ({ orders, block }) => {
  let currentLocation = JSON.parse(
    window.sessionStorage.getItem("iplookup")
  ).countryCode;

  const { t, i18n } = useTranslation();
  console.log("OrdersPartial", orders);
  const { currentUser } = useAuth();
  return (
    <div>
      {orders.map((order, idx) => (
        <Box key={idx} className="textBox" style={{ marginBottom: "20px" }}>
          <Box
            sx={{
              fontSize: "13px",
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid #e0e0e0",
              paddingBottom: "10px",
            }}
          >
            <Box sx={{ fontSize: "13px" }}>
              {t("Order Placed")} :{" "}
              {order?.created &&
                order?.created?.toDate().toLocaleDateString("fr-CA", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })}{" "}
              {/* {order?.created &&
                order?.created?.toDate().toLocaleTimeString("ko-KR")} */}
            </Box>
            <Box sx={{ fontSize: "13px", display: "flex" }}>
              <Box
                className=""
                sx={{ ml: 2, color: "#153a5a", display: "flex" }}
              >
                <HashLink to={"/contact/" + order.id + "#top"}>
                  {t("Contact Us")}
                </HashLink>
                {/* <Box sx={{ ml: 2 }}>Print Receipt</Box> */}
              </Box>
            </Box>
          </Box>

          <Box sx={{ pt: 2, fontSize: "13px" }}>
            <span className="gray">{t("Order")} #:</span> {order.id}
          </Box>
          <Box sx={{ color: "black", fontSize: "13px" }}>
            <span className="gray">{t("Status")}:</span>{" "}
            <span className="" style={{ fontWeight: "bold" }}>
              {t(order.status[order.status.length - 1])}
            </span>
          </Box>
          <Box sx={{ pb: 1, pt: 1, fontWeight: 600 }}>{t("ORDER DETAILS")}</Box>
          {order.address_address && (
            <Box sx={{ fontSize: "13px" }}>
              <span className="gray">{t("Ship to")}:</span>{" "}
              {order.address_lastname}
              &nbsp;{order.address_firstname}&nbsp;{order.address_address}&nbsp;
              {order.address_apt}&nbsp;{order.address_city}&nbsp;
              {order.address_state}&nbsp;{order.address_zipcode}
            </Box>
          )}
          <Box
            sx={{
              fontSize: "13px",
              pt: 2,
              color: "#757575",
              display: "flex",
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <Box>
              {JSON.parse(order.basket).map((item, idx) => {
                // console.log(item);
                let link =
                  "/dashboard-leave-a-new-review?productId=" +
                  item.id +
                  "&name=" +
                  item.name +
                  "&link" +
                  item.linkTo +
                  "&id=" +
                  currentUser.uid +
                  "#top";
                // console.log(link);
                return (
                  <Box key={idx} sx={{ color: "gray" }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        pl: 3,
                        pb: 1,
                      }}
                    >
                      <img src={item.image} alt="" width="50" />
                      <Box
                        sx={{ display: "flex", flexDirection: "column", pl: 2 }}
                      >
                        <Box sx={{ position: "relative", top: "+3px" }}>
                          {item.quantity}x {t(item.name)}&nbsp;
                        </Box>
                        <Box
                          className="pink_link"
                          sx={{
                            fontSize: "13px",
                            cursor: "pointer",
                            position: "relative",
                            top: "-1px",
                          }}
                        >
                          {/* http://localhost:55440/dashboard-edit-review?productId=prod_L0ydT6J1tc5YaN&name=Premium%20All-Purpose%20Wipes&link=dashboard-review&id=15c4RZ2SQD5A7aA2ca5Y */}
                          {!block && (
                            <HashLink to={link}>{t("Leave a review")}</HashLink>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                minWidth: "200px",
              }}
            >
              <Box sx={{ fontSize: "16px", color: "black", pb: 2 }}>
                {t("Total Price2")}:{" "}
                {order.finalPrice && (
                  <CurrencyFormat
                    decimalScale={2}
                    value={order.finalPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    suffix={"원"}
                  />
                )}
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box>{t("subtotal")}</Box>
                <Box>
                  {order.subtotal && (
                    <CurrencyFormat
                      decimalScale={2}
                      value={order.subtotal}
                      displayType={"text"}
                      thousandSeparator={true}
                      suffix={"원"}
                    />
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  pb: 1,
                }}
              >
                <Box>{t("Shipping fee")}</Box>
                <Box>
                  {order.shippingPrice && (
                    <CurrencyFormat
                      decimalScale={2}
                      value={order.shippingPrice}
                      displayType={"text"}
                      thousandSeparator={true}
                      suffix={"원"}
                    />
                  )}
                </Box>
              </Box>

              <Box sx={{ borderTop: "1px solid lightgray", pt: 1 }}></Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box>{t("Total")}</Box>
                <Box>
                  {order.finalPrice && (
                    <CurrencyFormat
                      decimalScale={2}
                      value={order.finalPrice}
                      displayType={"text"}
                      thousandSeparator={true}
                      suffix={"원"}
                    />
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                pl: 2,
                pt: 2,
                color: "#153a5a",
                fontSize: "13px",
                textDecoration: "underline",
              }}
            >
              <HelpDrawerText />
            </Box>
            {/* <Box
              sx={{
                fontSize: "13px",
                color: "#153a5a",
                pl: 1,
                position: "relative",
                top: "+8px",
                textDecoration: "underline",
              }}
            >
              <EasyInvoiceSample />
            </Box> */}
          </Box>
        </Box>
      ))}
    </div>
  );
};

export default OrdersPartial;
